module.exports = __webpack_public_path__ + "img/icon_shopping_cart.4b530cc6.svg";